/** Product areas that are built but not shown yet; flip to `true` to bring them back. */
export const FEATURES = { analytics: true, reservations: false } as const;
